import {styled} from '../../styled-components';

export const ButtonStyle = styled.button`
    margin: 0 ${props => props.theme.spacing.units(1)};
    padding: 0;
    border: none;
    text-decoration: none;
    line-height: normal;
    background: transparent;
    color: #000;
    font-size: ${props => props.theme.typography.pxToRem(14)};
    font-family: ${props => props.theme.typography.fontFamily};

    &:disabled {
        cursor: default;
        pointer-events: none;
    }
`;

ButtonStyle.displayName = 'ButtonStyle';
